import React, { useEffect, useState } from "react";
import AccountLayoutWeb from "./AccountLayoutWeb";
import { formatWithCommas } from "../../../Utils/Toast";
import moment from "moment";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../../context/AuthContext";
const BalanceOverview = () => {
  const userCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.userCoins;
  });
  const [getLogData, setLogData] = useState("");
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 10,
  });
  const myStatementData = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.transactionLogs,
      search_params
    );
    if (status === 200) {
      if (response_users.success) {
        setLogData(response_users.results);
      }
    }
  };
  useEffect(() => {
    myStatementData();
  }, [search_params]);

  return (
    <AccountLayoutWeb>
      <div className="col-center report">
        <h2>Summary</h2>{" "}
        <div className="white-wrap">
          <dl className="head-balance">
            <dt>Your Balances</dt>
            <dd id="summaryTotalBalance">
              {formatWithCommas(userCoins?.totalCoins)} <span>BDT</span>
            </dd>
          </dl>
          <h3>Welcome,</h3>
          <p>
            View your account details here. You can manage funds, review and
            change your settings and see the performance of your betting
            activity.
          </p>
        </div>{" "}
        <table className="table-s" id="Matched_Table">
          <tbody>
            <tr>
              <th scope="col" className="text-left">
                Date
              </th>
              <th scope="col" className="text-end">
                Transaction No
              </th>
              <th scope="col" className="text-end">
                Debits
              </th>
              <th scope="col" className="text-end">
                Credits
              </th>{" "}
              <th scope="col" className="text-end">
                Balance
              </th>
              <th scope="col" className="text-end">
                Remark
              </th>
              <th scope="col" className="text-end">
                From/To
              </th>
            </tr>
          </tbody>

          {getLogData.data?.length > 0 ? (
            <tbody id="Matched_Content">
              {getLogData.data &&
                getLogData.data.map((item, key) => (
                  <tr key={key}>
                    <td style={{ textAlign: "left" }}>
                      {moment(item?.createdAt).format("YYYY-MM-DD hh:mm:ss")}
                    </td>
                    <td>{item?._id}</td>
                    <td>
                      {item?.transactionType === "credit" ? (
                        <span className="text-success">
                          {formatWithCommas(item?.amount)}
                        </span>
                      ) : (
                        "-"
                      )}{" "}
                    </td>
                    <td>
                      {item?.transactionType === "debit" ? (
                        <span className="text-danger">
                          {"(" + formatWithCommas(item?.amount) + ")"}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>{formatWithCommas(item?.newBalance)}</td>
                    <td>{item?.remark}</td>
                    <td>
                      {item?.createdByData?.username}{" "}
                      <span className="angle_unicode">▸</span>{" "}
                      {item?.userData?.username}
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <tbody id="Matched_Content">
              <tr
                id="noDataTemplate"
                style={{
                  display: "table-row",
                }}
              >
                <td className="no-data" colSpan="9">
                  <p>You have no bets in this time period.</p>
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </AccountLayoutWeb>
  );
};

export default BalanceOverview;
